module.exports = __webpack_public_path__ + "static/media/Disagg101-1.67ce7cbf.png";